<a class="btn {{ btnClass }}" href="tel:{{ supportPhone }}" (click)="onClick()"
    ><i class="fa fa-phone"></i> {{ 'common.call-support' | translate }}</a
>
